import * as React from "react";
import type { FC } from "react";
import { Gapped, Input } from "react-ui";

import { Caption, Row } from "../../FiasFnsManualEditor.styles";
import { AddressTypeField } from "../AddressTypeField";
import { getTypeSuggests } from "../AddressRow";
import { Control } from "../controlsPaths";
import { AddressLevel } from "../../../../FiasInput/Types/FiasTypes";

interface RoomProps {
    fullSizeAbbreviation: boolean;
    getValue: (control: Control) => string;
    onChange: (control: Control) => (next: string) => void;
}

const addressLevel = AddressLevel.FlatRoom;
const controlType = Control.RoomType;
const controlNumber = Control.RoomNumber;

export const Room: FC<RoomProps> = props => (
    <Row>
        <Caption>Помещение в пределах квартиры</Caption>
        <Gapped>
            <AddressTypeField
                width={80}
                maxLength={50}
                placeholder={"Тип"}
                data-tid={"RoomType"}
                fullSize={props.fullSizeAbbreviation}
                controlType={controlType}
                value={props.getValue(controlType)}
                onChange={props.onChange(controlType)}
                getSuggests={getTypeSuggests(addressLevel)}
            />
            <Input
                width={260}
                maxLength={260}
                placeholder={"Номер"}
                data-tid={"RoomNum"}
                value={props.getValue(controlNumber)}
                onValueChange={props.onChange(controlNumber)}
            />
        </Gapped>
    </Row>
);
